import "styles/sharedStyles/loading.scss";
import aboutusbig from "../images/aboutusbig.svg";
import aboutussmall from "../images/aboutussmall.svg";

const Loading = () => {
    return (
        <div className="loading">
            <img src={aboutussmall} className="smallloading" alt="" />
            <img src={aboutusbig} className="bigloading" alt="" />
        </div>
    );
};

export default Loading;
